import React from 'react';

import {Separator} from 'src/components/separator';

import {AutosuggestListCaption} from '@pb/kit-component-autosuggest-v2';

import {StringFilterItem, SuggestionType} from '../typedefs';

import {EventCodeSuggestionGroup} from './event-code-suggestion-group';

type Props = {
    summaryCaption: string,
    changeRequestItems: StringFilterItem[],
    eventItems: StringFilterItem[],
};

export const EventCodeSuggestionsList = ({
    summaryCaption,
    changeRequestItems,
    eventItems,
}: Props) => {
    const hasChangeRequestItems = changeRequestItems.length > 0;
    const hasEventItems = eventItems.length > 0;

    return (
        <>
            {summaryCaption ? (
                <AutosuggestListCaption>
                    {summaryCaption}
                </AutosuggestListCaption>
            ) : null}

            {hasChangeRequestItems ? (
                <EventCodeSuggestionGroup
                    type={SuggestionType.CHANGE_REQUEST}
                    items={changeRequestItems}
                />
            ) : null}

            {hasChangeRequestItems && hasEventItems ? <Separator/> : null}

            {hasEventItems ? (
                <EventCodeSuggestionGroup
                    type={SuggestionType.EVENTS}
                    items={eventItems}
                />
            ) : null}
        </>
    );
};
